export const changePriceFixationReducer = (state =null, action) => {
    switch (action.type) {
      case "CHANGE_PRICE_FIXATION":
        return action.payload.priceFixation;
      default:
        return state;
    }
  };
  